import { EvaluationCriteria } from '@src/main/modules/reports/shared/domain/evaluation.interface';
import { format } from 'date-fns';

export function parseEvaluationCriteria(
  criteria: EvaluationCriteria,
): Record<string, string | number> {
  const params: Record<string, string | number> = {};

  if (criteria.offset !== undefined) params.offset = criteria.offset;
  if (criteria.limit !== undefined) params.limit = criteria.limit;
  if (criteria.sortField) params.sortField = criteria.sortField;
  if (criteria.sortOrder) params.sortOrder = criteria.sortOrder;

  if (criteria.carrierCode) params.carrierCode = criteria.carrierCode;
  if (criteria.flightNumber) params.flightNumber = criteria.flightNumber;
  if (criteria.aircraftRegistration) params.aircraftRegistration = criteria.aircraftRegistration;
  if (criteria.airportFrom) params.airportFrom = criteria.airportFrom;
  if (criteria.airportTo) params.airportTo = criteria.airportTo;

  // Commercial-specific fields
  if (criteria.supervisorEmployeeId) params.supervisorEmployeeId = criteria.supervisorEmployeeId;
  if (criteria.evaluatedEmployeeId) params.evaluatedEmployeeId = criteria.evaluatedEmployeeId;

  // Flight-specific fields
  if (criteria.purserEmployeeId) params.purserEmployeeId = criteria.purserEmployeeId;

  if (criteria.flightSince) {
    params.flightSince = format(new Date(criteria.flightSince), 'yyyy-MM-dd');
  }
  if (criteria.flightUntil) {
    params.flightUntil = format(new Date(criteria.flightUntil), 'yyyy-MM-dd');
  }
  if (criteria.receptionSince) {
    params.receptionSince = criteria.receptionSince;
  }
  if (criteria.receptionUntil) {
    params.receptionUntil = criteria.receptionUntil;
  }

  return params;
}
